import { Component, OnInit } from '@angular/core';
import {
    ConsoleInstrumentation,
    ErrorsInstrumentation,
    initializeFaro,
    LogLevel,
    SessionInstrumentation,
    WebVitalsInstrumentation,
} from '@grafana/faro-web-sdk';

import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    template: `
      <div class="redirect-container">
        <div class="redirect-card">
          <!-- <div class="spinner" aria-hidden="true"></div> -->
          <p class="redirect-message">{{ redirectMessage }}</p>
        </div>
      </div>
      <router-outlet></router-outlet>
    `,
    styles: [`
      :host {
        display: block;
      }
      .redirect-container {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background-color: var(--color-background);
        padding: 1rem;
        animation: fadeIn 0.4s ease both;
      }
      .redirect-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.75rem;
        padding: 2.5rem 3rem;
        //background-color: var(--color-surface);
        border-radius: 16px;
        //box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);
        max-width: 360px;
        width: 100%;
      }
      .spinner {
        width: 36px;
        height: 36px;
        border: 3px solid var(--color-text-muted);
        border-top-color: var(--color-text);
        border-radius: 50%;
        animation: spin 0.75s linear infinite;
        opacity: 0.7;
      }
      .redirect-message {
        margin: 0;
        font-family: 'CircularXXWeb-regular', sans-serif;
        font-size: 0.9375rem;
        color: var(--color-text);
        text-align: center;
        line-height: 1.6;
      }
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to   { opacity: 1; transform: translateY(0); }
      }
    `],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  redirectMessage: string = 'Sie werden in Kürze weitergeleitet...';

  constructor() {
    this.setLanguage();
    this.applyColorScheme();
  }

  private applyColorScheme(): void {
    if (!environment.enableDarkMode) {
      document.documentElement.setAttribute('data-color-scheme', 'light');
      return;
    }
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    document.documentElement.setAttribute(
      'data-color-scheme',
      mq.matches ? 'dark' : 'light'
    );
    mq.addEventListener('change', (e: MediaQueryListEvent) => {
      document.documentElement.setAttribute(
        'data-color-scheme',
        e.matches ? 'dark' : 'light'
      );
    });
  }

  private setLanguage(): void {
    const browserLang = navigator.language || (navigator as any).userLanguage;
    const lang = browserLang.toLowerCase();
    console.log('Browser language detected:', lang);
    // Check if the browser language is English
    if (lang.startsWith('en')) {
      this.redirectMessage = 'You will be redirected shortly...';
    } else {
      // Default to German
      this.redirectMessage = 'Sie werden in Kürze weitergeleitet...';
    }
  }

  ngOnInit() {
    if (environment.production) {
      initializeFaro({
        url: 'https://faro-collector-prod-eu-west-3.grafana.net/collect/364052b7571447378c84cc1dacf7b97a',
        app: {
          name: 'sso.bawaggroup.com',
          version: '1.0.0',
          environment: 'production',
        },
        instrumentations: [
          new ErrorsInstrumentation(),
          new WebVitalsInstrumentation(),
          new ConsoleInstrumentation({
            disabledLevels: [LogLevel.TRACE, LogLevel.ERROR],
          }),
          new SessionInstrumentation(),
        ],
      });
    }
  }
}
